export default "__VITE_ASSET__Dto3gzrI__"